import { MenuItem, Select, Checkbox, ListItemText, ListItemIcon, FormControl } from "@material-ui/core"
import React, { Component } from "react"
import { connect, ConnectedProps } from "react-redux"
import { RootState } from "../../reducers/rootReducer"
import { setCoils, setCurrentCoil, setMultipleCurrentCoil, toggleCoilDropdown } from "../../slices/coilSlice"
import { setCoilgroups, setCurrentCoilGroup, setCurrentCoilGroupId } from '../../slices/coilGroupSlice'
import { REACT_APP_APIM_URL } from "../../utilities/GlobalConstants"
import store from "../..";
import { getCameraByCoilgroup, getCoilGroups, getCoilgroups } from "../../configuration"
import { getToken, isCoilNumberIncludesInOut, removeCoilNumberFromCoilName } from "../../utilities/helperFunctions"
import { AuthContextProps, withAuth } from "react-oidc-context"

interface ICoilSelector {
    data: string[],
    showMultiCoilSelector?: boolean
}

interface OIDCAuth {
    auth?: AuthContextProps
  }
  

const mapStateToProps = (state: RootState) => {
    return {
        coil: state.coil,
        currCamera: state.camera.name,
        currCoilGroup: state.coilGroup.name,
        currentFurnaceId: state.scenarioSimulator.currentFurnaceId,
    }
}

const mapDispatchToProps = dispatch => {
    return {
        setCurrentCoil: (name: string) => dispatch(setCurrentCoil(name)),
        setCoil: (name: string[]) => dispatch(setCoils(name)),
        setMultipleCurrentCoil: (name: string[]) => dispatch(setMultipleCurrentCoil(name)),
        toggleCoilDropdown: (name: boolean) => dispatch(toggleCoilDropdown(name)),
        setCoilgroups: (values: string[]) => dispatch(setCoilgroups(values)),
        setCurrentCoilGroup: (name: string) => dispatch(setCurrentCoilGroup(name)),
        setCurrentCoilGroupId: (id: string) => dispatch(setCurrentCoilGroupId(id)),
    }
}

const connector = connect(mapStateToProps, mapDispatchToProps)

type PropsFromRedux = ConnectedProps<typeof connector>;

type ICoilSelectorReduxProps = PropsFromRedux & ICoilSelector & OIDCAuth;

type ICoilSelectorState = {
    coil: string[],
    currCoil: string,
    currCamera: string,
    selectedCoils: string[]
    isAllSelected: boolean,
    currCoilGroup: string,
    coilDropdownDisabled: boolean
}
class CoilSelector extends Component<ICoilSelectorReduxProps, ICoilSelectorState>{

    constructor(props) {
        super(props);

        this.state = {
            coil: this.props.coil.coils,
            currCoil: this.props.coil.currentCoil,
            currCamera: this.props.currCamera,
            selectedCoils: this.props.coil.multipleCurrentCoil || [],
            isAllSelected: false,
            currCoilGroup: this.props.currCoilGroup,
            coilDropdownDisabled: this.props.coil.coilDropdownDisabled
        }
    }
    
    fetchCoilsData = () => {
        getToken(this.props.auth).then((accessToken) => {
            fetch(`${REACT_APP_APIM_URL}/thermalimage/getCameraCoilConfig`, {
                method: "GET",
                headers: {
                    Accept: "*/*",
                    "Content-Type": "application/json",
                    Authorization: "Bearer " + accessToken,
                    "Access-Control-Allow-Origin": "*"
                },
            })
                .then((res) => res.json())
                .then(
                    (data) => {
                        let mappedArray: any[] = [];
                        if(this.props.showMultiCoilSelector)
                        {
                            let selectedCoilgroup = this.props.currCoilGroup;
                            let cameraForSelectedCoilgroup = "";
                            if(selectedCoilgroup !== "ALL")
                            {
                                let cameraData = getCameraByCoilgroup(selectedCoilgroup);
                                cameraForSelectedCoilgroup = cameraData[0].display_name;
                                const result = data.filter(d => d.camera === this.props.currCamera)
                                let filteredCoilsBySelectedCoilgroup = result[0]?.coils.filter((coil) => coil.includes(`CG-${selectedCoilgroup}`))
                                for (const d of filteredCoilsBySelectedCoilgroup) {
                                    if (isCoilNumberIncludesInOut(d)) {
                                    if (d.includes("OUT"))
                                        mappedArray.push(d);
                                    } else {
                                        //remove coil number from coilname and store it in mapped array and each coil should be unique
                                        const coilNameWithoutCoilNumber = removeCoilNumberFromCoilName(d) 
                                        if(!mappedArray.includes(coilNameWithoutCoilNumber)) {
                                            mappedArray.push(coilNameWithoutCoilNumber)
                                        }
                                    }
                                }
                            }
                            else
                            {
                                const result = data
                                for(let i = 0 ; i < result.length; i++){
                                    for (const d of result[i]?.coils) {
                                    if (isCoilNumberIncludesInOut(d)) {
                                        if (d.includes("OUT"))
                                            mappedArray.push(d);
                                    } else {
                                        //remove coil number from coilname and store it in mapped array and each coil should be unique
                                        const coilNameWithoutCoilNumber = removeCoilNumberFromCoilName(d) 
                                        mappedArray.push(coilNameWithoutCoilNumber)
                                        if(!mappedArray.includes(coilNameWithoutCoilNumber)) {
                                            mappedArray.push(coilNameWithoutCoilNumber)
                                        }
                                    }
                                    }
                                }
                            }
                            
                        }
                        else
                        {
                            const result = data.filter(d => d.camera === this.props.currCamera)
                            for (const d of result[0]?.coils) {
                                if (isCoilNumberIncludesInOut(d)) {
                                if (d.includes("OUT"))
                                    mappedArray.push(d);
                                } else {
                                    //remove coil number from coilname and store it in mapped array and each coil should be unique
                                    const coilNameWithoutCoilNumber = removeCoilNumberFromCoilName(d) 
                                    if(!mappedArray.includes(coilNameWithoutCoilNumber)) {
                                        mappedArray.push(coilNameWithoutCoilNumber)
                                    }                                
                                }
                            }
                        }
                        this.props.setCoil(mappedArray)
                        const isAllSelectedVal =
                            mappedArray.length > 0 && this.state.selectedCoils.length === mappedArray.length;
                        this.setState({ isAllSelected: isAllSelectedVal })
                        this.setState({
                            coil: mappedArray
                        });
                        // let coilGroups = getCoilgroups(this.props.currentFurnaceId);
                        // coilGroups = coilGroups && coilGroups.filter((cg,i, cgs) => cgs.indexOf(cg) === i)
                        // const allCoilGroups: any[] = [];
                        // coilGroups.forEach(x => {
                        //     allCoilGroups.push(x.name)
                        // });
                        // this.props.setCoilgroups(allCoilGroups)
                    },
                    (error) => console.log("error", error)
                )
        })
    }

    componentDidMount(): void {
        this.props.toggleCoilDropdown(false)
        this.fetchCoilsData();
        this.setState({
            currCoil: this.props.coil.currentCoil
        })
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.data !== this.props.data) {
            this.setState({
                coil: this.props.data.filter(x => x.includes("OUT")),
            });
        }

        if (this.state.currCoil !== this.props.coil.currentCoil) {
            this.setState({
                currCoil: this.props.coil.currentCoil
            })
        }

        if(prevProps.currCoilGroup !== this.props.currCoilGroup)
        {
            this.fetchCoilsData()
            this.setState({
                selectedCoils: []
            });
        }

        if(this.state.coilDropdownDisabled !== this.props.coil.coilDropdownDisabled)
        {
            this.setState({
                coilDropdownDisabled: this.props.coil.coilDropdownDisabled
            })
        }
    }

    handleSelection = (e) => {
        if(this.props.showMultiCoilSelector){

            const newVal: Array<string> = e.target.value;
            if(newVal.length <= 12 && newVal.length > 0)
            {
                this.props.toggleCoilDropdown(true)
                var currSelectedCoilGroup = this.props.currCoilGroup;
                const newValArray: Array<string> = [];
                for(var i = 0; i<newVal.length; i++)
                {
                    if(newVal[i].includes("CG-"+currSelectedCoilGroup))
                    {
                        newValArray.push(newVal[i])
                    }
                }
                
                if (e.target.value.includes("all"))
                { 
                    const isAllSelectedVal =
                    this.state.coil.length > 0 && this.state.selectedCoils.length === this.state.coil.length;
                    this.setState({
                        selectedCoils: isAllSelectedVal ? [] : this.state.coil
                    });
                    isAllSelectedVal ? this.props.setMultipleCurrentCoil([]) : this.props.setMultipleCurrentCoil(this.state.coil)
                    this.setState({isAllSelected : !isAllSelectedVal}) 
                    this.props.toggleCoilDropdown(false);
                    return;
                }
                const isAllSelectedVal =
                    this.state.coil.length > 0 && newValArray.length === this.state.coil.length;
                    this.setState({isAllSelected : isAllSelectedVal}) 
                this.setState({
                    selectedCoils: newValArray
                });
                this.props.setMultipleCurrentCoil(newValArray);
                this.props.toggleCoilDropdown(false);
            }
            else
            {
                this.setState({
                    selectedCoils: []
                });
                this.props.toggleCoilDropdown(false)
                this.setState({isAllSelected : false}) 
                this.props.setMultipleCurrentCoil([]);
            }
        }
        else{
            const newVal: string = e.target.value;
            this.props.setMultipleCurrentCoil([newVal]);
            let currCoilGroupName = newVal.split("CG-")[1].split("_")[0]
            let currCoilGroup = getCoilGroups().filter((coilgroup) => coilgroup.name == currCoilGroupName)
            this.props.setCurrentCoilGroup(currCoilGroupName);
            this.props.setCurrentCoilGroupId((currCoilGroup[0].id).toString())
            this.props.setCurrentCoil(newVal);
        }
    }
    render(): React.ReactNode {
        return (
            <div className="control-header element">
                <div className="container-typography">
                    <b>Coil: </b>
                </div>
                <FormControl style={{width: 500}}>
                {this.props.showMultiCoilSelector && <Select multiple value={this.state.selectedCoils} disabled={this.state.coilDropdownDisabled} onChange={(event) => this.handleSelection(event)} 
                renderValue={(p: string[] | any) => p.join(", ")}>
                <MenuItem
                    disabled={this.state.coilDropdownDisabled}
                    value="all"
                    >
                    <ListItemIcon>
                        <Checkbox
                        style ={{
                            color: "#435591",
                        }}
                        checked={this.state.isAllSelected}
                        indeterminate={
                            this.state.selectedCoils.length > 0 && this.state.selectedCoils.length < this.state.coil.length
                        }
                        />
                    </ListItemIcon>
                    <ListItemText
                        primary="Select All"
                    />
                    </MenuItem>
                    {this.state.coil?.map((coil, i) => (
                        <MenuItem key={`COIL-SELECT-${coil}`} disabled={this.state.coilDropdownDisabled} value={coil}>
                            <Checkbox
                                style ={{
                                    color: "#435591",
                                }}
                                checked={this.state?.selectedCoils.findIndex((item) => item === coil) >= 0
                                }
                            />
                            <ListItemText primary={coil} />
                        </MenuItem>
                    ))}
                </Select>}

                {!this.props.showMultiCoilSelector && <Select autoWidth value={this.state.currCoil} onChange={(event) => this.handleSelection(event)} style={{ width: "100%" }}>
                    {this.state.coil?.map((coil, i) => (
                        <MenuItem key={`COIL-SELECT-${coil}`} value={coil}>
                            {coil}
                        </MenuItem>
                    ))}
                </Select>}
                </FormControl>
            </div>
        )
    }
}

export default withAuth(connector(CoilSelector));